import "./SiteConfigurationGroupGuardCompaniesInfo.html";
import "./SiteConfigurationGroupGuardCompaniesInfo.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";

// tslint:disable-next-line:max-line-length
import SiteConfigurationGroupGuardCompaniesInfoComponentController from "./SiteConfigurationGroupGuardCompaniesInfoComponentController";

export class SiteConfigurationGroupGuardCompaniesInfoComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            guardCompaniesList: "<",
        };
        this.controller = SiteConfigurationGroupGuardCompaniesInfoComponentController;
        this.templateUrl =
            "/App/Components/Site/ConfigurationGroups/" +
            "Info/GuardCompanies/SiteConfigurationGroupGuardCompaniesInfo.html";
    }
}

module("mmManagePortal").component(
    "irSiteConfigurationGroupGuardCompaniesInfo",
    new SiteConfigurationGroupGuardCompaniesInfoComponent(),
);
